import { Card, CardHeader, Grid, Typography, CardContent, Divider, Checkbox } from '@material-ui/core';
import React from 'react';
import classes from '../../../pages/createOrder/index.module.scss'

function OrderResendInfo(props: any) {
    const {
        form,
        children,
        cod,
        setCod,
        deliveryLocationType,
        setDeliveryLocationType,
        fulfillmentService,
        setFulfillmentService,
        notifType
    } = props
    const {
        getValues,
    } = form
    const values = getValues();

    return (
        <Card className={classes.card}>
            <CardHeader
                avatar={
                    <Grid>
                        <Typography className={classes.typographyCards}>
                            اطلاعات سفارش
                        </Typography>
                    </Grid>
                }
            />

            <CardContent className={classes.cardContentOrder}>
                <Grid container spacing={2}>
                    {children}
                </Grid>
                <Divider style={{ marginTop: '10px', marginBottom: '-10px' }} />
                <Grid container spacing={1} xs={12} sm={12} md={12} lg={12}>
                    <Grid
                        item
                        xs={12}
                        sm={3}
                        md={2}
                        lg={2}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <span className={classes.label}>
                                <Checkbox
                                    checked={fulfillmentService}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setCod(false)
                                        }
                                        setFulfillmentService(e.target.checked);
                                    }}
                                    disabled
                                    color="secondary"
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                    }}
                                    data-cy="fulfillmentServiceCheckBox"
                                />
                            </span>

                            <div
                                style={{
                                    width: '100%',
                                    marginTop: '20px',
                                }}
                            >
                                <span>خدمات مرکز پردازش دیجی کالا</span>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={3}
                        md={2}
                        lg={2}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <span className={classes.label}>
                                <Checkbox
                                    checked={deliveryLocationType}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setCod(false)
                                        }
                                        setDeliveryLocationType(e.target.checked);
                                    }}
                                    disabled={values.returnStatus !== "REQUESTED_TO_RESEND"}
                                    color="secondary"
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                    }}
                                    data-cy="fulfillmentServiceCheckBox"
                                />
                            </span>

                            <div
                                style={{
                                    width: '100%',
                                    marginTop: '20px',
                                }}
                            >
                                <span>تحویل درب انبار </span>
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={2}
                        alignItems="flex-start"
                    >
                        <div className={classes.item}>
                            <span className={classes.label}>
                                <Checkbox
                                    checked={cod}
                                    disabled
                                    onChange={e => {
                                        if (e.target.checked) {
                                            setFulfillmentService(false);
                                            setDeliveryLocationType(false);
                                        }
                                        setCod(e.target.checked);
                                    }}
                                    color="secondary"
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                    }}
                                />
                            </span>

                            <div
                                style={{
                                    width: '100%',
                                    marginTop: '20px',
                                }}
                            >
                                <span>پرداخت در محل (COD)</span>
                            </div>
                        </div>
                    </Grid>
                    {/* {notifType == "COURIER" && <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Typography style={{ marginTop: "20px", border: "1px solid #dfa02e", padding: "0 12px", borderRadius: "7px", fontSize: "15px" }}>
                            محدوده تحت پوشش سرویس عادی شامل <span style={{ fontWeight: "bold" }}>مناطق 22 گانه تهران به جز شهرک های قصرفیروزه، شهید باقری، آتی شهر و ضلع شمالی اتوبان بابایی بعد از جاده لشگرک</span> می باشد. جهت بهبود فرآیند ارسال به این مناطق لطفا از سرویس پست استفاده نمایید
                        </Typography>
                    </Grid>} */}
                    {notifType == "deliveryLocation" && <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Typography style={{ marginTop: "20px", border: "1px solid #dfa02e", padding: "10px 12px", borderRadius: "7px", fontSize: "15px" }}>
                            امکان تحویل سفارش درب انبار تا ساعت 17 شنبه تا چهارشنبه و 12 ظهر برای پنج شنبه می باشد
                        </Typography>
                    </Grid>}
                    {/* KEEP the line below maybe products change their mind */}
                    {/* {fulfillmentService && (
                        <Grid
                            item
                            xs={3}
                            sm={3}
                            md={3}
                            lg={3}
                            alignItems="flex-start"
                        >
                            <div className={classes.item}>
                                <div
                                    style={{ width: '100%', marginTop: '20px' }}
                                    data-cy="fulfillmentLine"
                                >
                                    <FormControl style={{ width: '100%' }}>
                                        <Autocomplete
                                            disableClearable
                                            getOptionSelected={(option, value) =>
                                                option.name === value?.name
                                            }
                                            getOptionLabel={option => option.name}
                                            options={fulfillmentLines}
                                            value={fulfillmentLine}
                                            loading={fulfillmentLineLoading}
                                            onChange={(event: any, newValue: any) => {
                                                setFulfillmentLine(newValue);
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    type="search"
                                                    variant="outlined"
                                                    {...params}
                                                    label="مرکز پردازش"
                                                    inputRef={register({
                                                        required: fulfillmentService,
                                                    })}
                                                    name="fulfillmentLine"
                                                    id="fulfillmentLine"
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <React.Fragment>
                                                                {fulfillmentLineLoading ? (
                                                                    <CircularProgress
                                                                        color="inherit"
                                                                        size={20}
                                                                    />
                                                                ) : null}
                                                                {params.InputProps.endAdornment}
                                                            </React.Fragment>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                    <FormHelperText error focused>
                                        {!fulfillmentLine &&
                                            fulfillmentService &&
                                            'مرکز پردازش الزامی میباشد'}
                                    </FormHelperText>
                                </div>
                            </div>
                        </Grid>
                    )} */}
                </Grid>
            </CardContent>
        </Card>
    )
}

export default OrderResendInfo;